export default "__VITE_ASSET__f74cba53__"